export default __webpack_public_path__ + "static/media/iRspond.606cde83.svg";